"use client"

// src/tokens/font-weights.ts
var fontWeights = {
  hairline: 100,
  thin: 200,
  light: 300,
  normal: 400,
  medium: 500,
  semibold: 600,
  bold: 700,
  extrabold: 800,
  black: 900
};

export {
  fontWeights
};
//# sourceMappingURL=chunk-PLCZVXUS.mjs.map